<template>
	<div class="plate_text cursor-pointer" :class="{ highlighted: selected }" @click="$emit('click', plate_code)" :style="getPercentStyle(pct)">
		<span>{{plate_name+" "+c_num}}</span>
	</div>
</template>

<script>
	export default {
		props: {
			plate_code: String,
			plate_name: String,
			pct: Number,
			c_num: [Number],
			selected: Boolean,
		},
		data() {
			return {

			};
		},
		computed: {

		},
		methods: {
			getPercentStyle(pt) {
                const val = parseFloat(pt);
                if (isNaN(val) || val === 0) return {};

                const color = val > 0 ? '251, 16, 35' : '39, 139, 34'; // #FB1023 or #278B22
                const opacity = Math.min(Math.abs(val) / 10, 0.6);
                
				return {
					'--pt-overlay': `rgba(${color}, ${opacity})`
				}
			},
		}

	}
</script>

<style scoped>
	.plate_text {
		border: 1px solid var(--border-color, lightgray);
		color: var(--text-main, #333);
        border-radius: 4px;
        padding: 2px 4px;
        transition: all 0.2s;
        background-color: var(--bg-card, #fff);
        position: relative;
        z-index: 1;
	}

    .plate_text::before {
        content: "";
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: var(--pt-overlay, transparent);
        z-index: -1;
        border-radius: 3px;
    }

	.highlighted {
		background-color: var(--accent-color, gold) !important;
		color: #fff !important;
		border: 2px solid var(--color-up-color, red);
        box-shadow: 0 0 8px var(--accent-color);
	}
</style>
